export const DETAIL_START = 'DETAIL_START';
export const DETAIL_SUCCESS = 'DETAIL_SUCCESS';
export const DETAIL_ERROR = 'DETAIL_ERROR';

// WalletBalance Action
export const GET_BALANCE_START = 'GET_BALANCE_START';
export const GET_BALANCE_SUCCESS = 'GET_BALANCE_SUCCESS';
export const GET_BALANCE_ERROR = 'GET_BALANCE_ERROR';

// connect Action
export const CONNECT_WALLET_START = 'CONNECT_WALLET_START';
export const CONNECT_WALLET_SUCCESS = 'CONNECT_WALLET_SUCCESS';
export const CONNECT_WALLET_ERROR = 'CONNECT_WALLET_ERROR';

// disconnect Action
export const DISCONNECT_WALLET_SUCCESS = 'DISCONNECT_WALLET_SUCCESS';

export const ERROR_POPUP_START = 'ERROR_POPUP_START';
export const ERROR_POPUP_STOP = 'ERROR_POPUP_STOP';

export const UI_LOADER_START = 'UI_LOADER_START';
export const UI_LOADER_STOP = 'UI_LOADER_STOP';

export const LOGIN_START = 'LOGIN_START';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const RESET_PASSWORD_START = 'RESET_PASSWORD_START';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
export const SIGN_OUT_START = 'SIGN_OUT_START';
export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS';
export const SIGN_OUT_ERROR = 'SIGN_OUT_ERROR';
export const UI_NAV_TOGGLE = 'UI_NAV_TOGGLE';

export const ADDRESS_CHANGE = 'ADDRESS_CHANGE';
